import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2';

const Scrollable = (props) => {
    return (
        <Scrollbars
            className="h-100">
            <div 
            style={{ paddingLeft: props.noPadding ? 0 : 10, paddingRight: props.noPadding ? 0 : 10 }} 
            className={"h-100 py-2"}>
                {props.children}
            </div>
        </Scrollbars>
    )
}
export default Scrollable;